export function ChildTabBar({
  childList,
  activeIdx,
  setActiveIdx,
  onAdd,
  onRemove,
  maxChildren,
  childErrMap,
}) {
  maxChildren = maxChildren || 5;
  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        marginBottom: 18,
        overflowX: "auto",
        paddingBottom: 4,
        flexWrap: "wrap",
      }}
    >
      {childList.map(function (child, i) {
        var isActive = i === activeIdx;
        var hasData = !!(
          child.fees.length > 0 ||
          child.uniforms ||
          child.shoes ||
          child.laptop ||
          child.gender ||
          child.yearLevel ||
          child.schoolName
        );
        return (
          <div key={child._key} style={{ display: "flex", alignItems: "center", gap: 0 }}>
            <button
              onClick={function () {
                setActiveIdx(i);
              }}
              style={{
                background: isActive ? "#00695C" : "#FFFFFF",
                color: isActive ? "#FFFFFF" : "#607D79",
                border: `1px solid ${isActive ? "#00695C" : "#CFE0DE"}`,
                borderRadius: childList.length > 1 ? "8px 0 0 8px" : "8px",
                padding: "8px 14px",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              {`Child ${i + 1}`}
              {childErrMap?.[i] && Object.keys(childErrMap[i]).length > 0 ? (
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: isActive ? "rgba(255,255,255,0.8)" : "#C62828",
                    display: "inline-block",
                  }}
                  title="Has errors"
                />
              ) : (
                hasData && (
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: isActive ? "rgba(255,255,255,0.8)" : "#00897B",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                )
              )}
            </button>
            {childList.length > 1 && (
              <button
                onClick={function () {
                  onRemove(i);
                }}
                title="Remove this child"
                style={{
                  background: isActive ? "#00695C" : "#F5F5F5",
                  color: isActive ? "rgba(255,255,255,0.7)" : "#607D79",
                  border: `1px solid ${isActive ? "#00695C" : "#CFE0DE"}`,
                  borderLeft: "none",
                  borderRadius: "0 8px 8px 0",
                  padding: "8px 8px",
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "inherit",
                  lineHeight: 1,
                }}
              >
                {"×"}
              </button>
            )}
          </div>
        );
      })}
      {childList.length < maxChildren && (
        <button
          onClick={onAdd}
          style={{
            background: "none",
            color: "#00897B",
            border: `1px dashed ${"#00897B"}`,
            borderRadius: 8,
            padding: "8px 14px",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
            whiteSpace: "nowrap",
          }}
        >
          {"+ Add child"}
        </button>
      )}
    </div>
  );
}
